import { render } from "./AccountingTab.vue?vue&type=template&id=4a234176&scoped=true"
import script from "./AccountingTab.vue?vue&type=script&lang=js"
export * from "./AccountingTab.vue?vue&type=script&lang=js"

import "./AccountingTab.vue?vue&type=style&index=0&id=4a234176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a234176"]])

export default __exports__